export const DChartAxisTickPosition = wcardinal.ui.DChartAxisTickPosition;